<template>
  <div class="reservation-promo-input">
    <div class="form-group clearfix" :class="{ 'has-feedback' : field.dirty }">
      <label :for="field.name" class="col-sm-4 control-label">
        {{ field.label }}
        <span v-if="field.required" class="required">*</span>
      </label>
      <div class="col-sm-8">
        <input :readonly="readOnly" :id="field.name" class="form-control" type="text" v-model="field.value" :name="field.name" debounce="500"/>
        <span class="form-validation-info" v-show="readOnly">Cannot modify promotional code</span>
        <span class="form-validation-info" v-show="loading">Verifying code...</span>
        <span class="form-validation-error" v-show="!isValid">{{ field.value }} is not a valid promo code</span>
        <span class="form-validation-error" v-show="errorMessage">{{ errorMessage }}</span>
        <span class="form-validation-info" v-show="description">{{ description }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReservationPromoInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          value: '',
          validCode: false,
          dirty: false
        }
      }
    },
    readOnly: {
      type: Boolean,
      default () {
        return false
      }
    },
    car: {
      type: String,
      default () {
        return ''
      }
    },
    user: {
      type: String,
      default () {
        return ''
      }
    },
    date: {
      type: Object,
      default () {
        return {
          startDate: new Date(),
          endDate: new Date()
        }
      }
    }
  },
  data () {
    return {
      isValid: true,
      errorMessage: false,
      loading: false,
      description: false
    }
  },
  methods: {
    validateField () {
      if (!this.field.value) this.field.value = ''
      if (this.field.value.length > 0) {
        this.errorMessage = false
        this.isValid = true
        this.description = false
        this.field.dirty = true
        this.loading = true
        this.$http.post('private/reserve/promo', {
          code: this.field.value,
          car: this.car,
          user: this.user,
          startDate: this.date.startDate,
          endDate: this.date.endDate
        }).then(({data}, status, request) => {
          if (data.invalid) {
            this.isValid = false
            this.field.validCode = false
          } else if (data.errorMessage) {
            this.errorMessage = data.errorMessage
            this.field.validCode = false
          } else {
            this.description = data.code.description
            this.field.validCode = true
            this.$dispatch('promoCodeActivated', data.code)
          }
          this.loading = false
        }).catch(err => {
          this.field.validCode = false
          console.log(err)
        })
      }
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField()
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReservationPromoInput.vue?31864ac7